export const ONBOARDING_CITIES = [
  'Bogotá D.C.',
  'Medellín',
  'Cali',
  'Barranquilla',
  'Cartagena',
  'Bucaramanga',
  'Cúcuta',
  'Ibagué',
  'Pereira',
  'Santa Marta',
];

export const ONBOARDING_ZONES: Record<string, { question: string; zones: string[] }> = {
  'Bogotá D.C.': {
    question: "Perfecto. ¿En qué localidades de Bogotá te enfocas?",
    zones: ['Usaquén', 'Chapinero', 'Santa Fe', 'San Cristóbal', 'Usme', 'Tunjuelito', 'Bosa', 'Kennedy', 'Fontibón', 'Engativá', 'Suba', 'Barrios Unidos', 'Teusaquillo', 'Los Mártires', 'Antonio Nariño', 'Puente Aranda', 'La Candelaria', 'Rafael Uribe Uribe', 'Ciudad Bolívar'],
  },
  'Medellín': {
    question: "Entendido. ¿En qué comunas de Medellín trabajas?",
    zones: ['Popular', 'Santa Cruz', 'Manrique', 'Aranjuez', 'Castilla', 'Doce de Octubre', 'Robledo', 'Villa Hermosa', 'Buenos Aires', 'La Candelaria', 'Laureles-Estadio', 'La América', 'San Javier', 'El Poblado', 'Guayabal', 'Belén'],
  },
  'Cali': {
    question: "¡Genial! ¿Qué comunas de Cali cubres?",
    zones: Array.from({ length: 22 }, (_, i) => `Comuna ${i + 1}`),
  },
  'Barranquilla': {
    question: "Ok. ¿En qué localidades de Barranquilla te mueves?",
    zones: ['Riomar', 'Norte-Centro Histórico', 'Sur Occidente', 'Metropolitana', 'Sur Oriente'],
  },
  'Cartagena': {
    question: "¿En qué localidades de Cartagena tienes propiedades?",
    zones: ['Histórica y del Caribe Norte', 'De la Virgen y Turística', 'Industrial de la Bahía'],
  },
  'Bucaramanga': {
    question: "¿Cuáles son tus comunas de trabajo en Bucaramanga?",
    zones: ['Cabecera del Llano', 'Centro', 'Ciudadela Real de Minas', 'El Provenza', 'García Rovira', 'La Concordia', 'La Pedregosa', 'Morrorico', 'Mutis', 'Norte', 'Nororiental', 'Occidental', 'Oriental', 'Suroccidente', 'Sur'],
  },
  'Cúcuta': {
    question: "¿En qué comunas de Cúcuta te especializas?",
    zones: Array.from({ length: 10 }, (_, i) => `Comuna ${i + 1}`),
  },
  'Ibagué': {
    question: "¿Qué comunas de Ibagué son tu fuerte?",
    zones: Array.from({ length: 13 }, (_, i) => `Comuna ${i + 1}`),
  },
  'Pereira': {
    question: "¿En qué comunas de Pereira operas?",
    zones: ['Ferrocarril', 'Olímpica', 'San Joaquín', 'Cuba', 'Consota', 'El Oso', 'Perla del Otún', 'El Rocío', 'Boston', 'El Jardín', 'San Nicolás', 'Centro', 'Río Otún', 'Villavicencio', 'Universidad', 'Villasantana', 'El Poblado', 'El Café', 'Cerritos'],
  },
  'Santa Marta': {
    question: "¿En qué comunas de Santa Marta te encuentras?",
    zones: ['Comuna 1 - Centro Histórico', 'Comuna 2 - Bavaria', 'Comuna 3 - Manzanares', 'Comuna 4 - Gaira-Rodadero', 'Comuna 5 - Mamatoco', 'Comuna 6 - Bonda', 'Comuna 7 - Taganga', 'Comuna 8 - El Pando', 'Comuna 9 - Bastidas'],
  }
};
